export default "__VITE_ASSET__DH5VO_$1__"